
import { defineComponent } from 'vue';
import { Form, Field } from 'vee-validate';
import Swal from 'sweetalert2/dist/sweetalert2.min.js';
// import * as Yup from "yup";
import ApiService from '@/core/services/ApiService';
import { VueCookieNext } from 'vue-cookie-next';

export default defineComponent({
  name: 'map-trainer-course-component',
  components: {
    Form,
    Field,
  },
  data() {
    return {
      trainerSelected: [] as any,
      trainer_ids: [],
      select_trainer_ids: [],
      loader: false,
      trainerInfos: [] as any,
      loading: false,
      courseInfoData: false,
      showCourseNotice: false,
      showCourseList: false,
      showMapCourseList: false,
      showtrainingProviderNotice: false,
      tranche_id: '',
      entity_id: '',
      institute_id: '',
      course_info_id: '',
      entityInfos: [] as any,
      showSubmit: false,
      load: false,
      tranches: [] as any,
      institutes: [] as any,
      tempCourseInfos: [] as any,
      courses: [] as any,
    };
  },
  async created() {
    await this.getEntityInfos();
    await this.getTranche();
  },
  methods: {
    async getTranche() {
      this.load = true;
      await ApiService.get('configurations/tranche/list')
        .then((response) => {
          this.tranches = response.data.data;
          this.load = false;
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },

    async formSubmit() {
      let formData = new FormData();
      this.loading = true;
      let user_id = VueCookieNext.getCookie('_seip_user');
      formData.set('user_id', user_id.id);
      formData.set('tranche_id', this.tranche_id);
      formData.set('entity_id', this.entity_id);
      formData.set('institute_id', this.institute_id);
      formData.set('course_info_id', this.course_info_id);
      formData.set('map_trainer_ids', JSON.stringify(this.trainerSelected));
      // formData.set('unmap_trainer_ids', JSON.stringify(this.trainerInfos));

      await ApiService.post('course/mapping/map_trainer_course_save', formData)
        .then((response) => {
          if (response.data.status == 'success') {
            Swal.fire({
              title: 'Success!',
              text: response.data.data,
              icon: 'success',
              buttonsStyling: false,
              confirmButtonText: 'Ok',
              customClass: {
                confirmButton: 'btn btn-success',
              },
            }).then(() => {
              // this.tranche_id = '';
              // this.entity_id = '';
              this.institute_id = '';
              this.course_info_id = '';
              (this.trainerInfos = [] as any),
                (this.trainerSelected = [] as any);
              this.loading = false;
              this.showSubmit = false;
            });
          }
          if (response.data.status == 'error') {
            Swal.fire({
              title: 'Error!',
              text: response.data.message,
              icon: 'error',
              buttonsStyling: false,
              confirmButtonText: 'Ok',
              customClass: {
                confirmButton: 'btn btn-danger',
              },
            }).then(() => {
              this.tranche_id = '';
              this.entity_id = '';
              this.institute_id = '';
              this.course_info_id = '';
              (this.trainerInfos = [] as any),
                (this.trainerSelected = [] as any);
              this.loading = false;
              this.showSubmit = false;
            });
          }
        })

        .catch(({ response }) => {
          this.loading = false;

          console.log(response);
        });
    },
    async getEntityInfos() {
      this.load = true;
      let entity_id = this.entity_id;
      if (VueCookieNext.getCookie('_seip_entity_type') != 1004) {
        entity_id = VueCookieNext.getCookie('_entity_id');
      }
      await ApiService.get('entity/list?entity_id=' + entity_id)
        .then((response) => {
          this.entityInfos = response.data.data;
          this.load = false;
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },

    selectedTrainers() {
      this.trainer_ids.forEach((item) => {
        // if not find any id (basically never find it )on right side then push else skip
        const alreadySelected = this.trainerSelected.some(
          (s_item) => s_item['id'] === item['id']
        );

        if (!alreadySelected) {
          this.trainerSelected.push(item);
          this.trainerInfos = this.trainerInfos.filter(
            (info) => info['id'] !== item['id']
          );
        }
      });
      // console.log(this.trainerInfos);
      // console.log(this.trainerSelected);
    },
    unselectedTrainers() {
      this.select_trainer_ids.forEach((item) => {
        const alreadyUnselected = this.trainerInfos.some(
          (s_item) => s_item['id'] === item['id']
        );

        if (!alreadyUnselected) {
          this.trainerInfos.push(item);
          this.trainerSelected = this.trainerSelected.filter(
            (selected) => selected['id'] !== item['id']
          );
        }
      });
    },

    selectAllTrainer() {
      Array.prototype.push.apply(this.trainerSelected, this.trainerInfos);
      this.trainerInfos.splice(0);
    },
    unselectAllTrainer() {
      Array.prototype.push.apply(this.trainerInfos, this.trainerSelected);
      this.trainerSelected.splice(0);
    },
    courseInfo() {
      this.courseInfoData = true;
    },

    async trainerList() {
      this.loader = true;
      await ApiService.get(
        'course/mapping/map_course_trainer?entity_id=' +
          this.entity_id +
          '&institute_id=' +
          this.institute_id +
          '&tranche_id=' +
          this.tranche_id +
          '&course_info_id=' +
          this.course_info_id
      )
        .then((response) => {
          this.trainerInfos = response.data.data.trainer_info;

          this.trainerSelected = response.data.data.map_info;
          console.log(this.trainerSelected);
          if (this.trainerSelected != '') {
            this.showSubmit = true;
          }
          // this.trainerSelected = this.mapInfo;
          this.loader = false;
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
    async trainerfirstList() {
      this.course_info_id = '';
      this.getCourseList();

      this.loader = true;
      await ApiService.get(
        'course/mapping/map_course_trainer?entity_id=' +
          this.entity_id +
          '&institute_id=' +
          this.institute_id +
          '&tranche_id=' +
          this.tranche_id +
          '&course_info_id=' +
          this.course_info_id
      )
        .then((response) => {
          this.trainerInfos = response.data.data.trainer_info;

          this.trainerSelected = response.data.data.map_info;
          console.log(this.trainerSelected);
          if (this.trainerSelected != '') {
            this.showSubmit = true;
          }
          // this.trainerSelected = this.mapInfo;
          this.loader = false;
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
    async getCourseList() {
      this.load = true;
      await ApiService.get(
        'course/list?entity_id=' +
          this.entity_id +
          '&tranche=' +
          this.tranche_id +
          '&institute_info_id=' +
          this.institute_id
      )
        .then((response) => {
          this.courses = [] as any;
          this.courses = response.data.data;

          this.load = false;
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
    async getInstituteInfo() {
      this.load = true;
      let entity_id = this.entity_id;
      if (VueCookieNext.getCookie('_seip_entity_type') != 1004) {
        entity_id = VueCookieNext.getCookie('_entity_id');
      }
      await ApiService.get('institute/list?entity_id=' + entity_id)
        .then((response) => {
          this.institutes = response.data.data;
          this.load = false;
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
    courseMapList() {
      this.showMapCourseList = true;
    },
    trainingProviderNotice() {
      this.showtrainingProviderNotice = true;
    },
  },
  setup() {
    const AssociationSchema = [];
    return {
      AssociationSchema,
    };
  },
});
